<template>
    <nav class="productsMenu" role="navigation">
        <ul>
            <li v-if="items.length==0" class="looping-rhombuses-spinner">
                <div class="rhombus"></div>
                <div class="rhombus"></div>
                <div class="rhombus"></div>
            </li>
        <li
                v-for="item in items" v-bind:key="item.code"
                class="subnav-item"
        >
            <a v-bind:href="'/menu/'+item.slug.replace('/','_')" v-bind:title="item.name"
            @click.prevent="goTo(item.slug.replace('/','_'))">
                {{item.name}}
            </a>
        </li>
        </ul>
    </nav>
</template>
<script>
    import axios from '../lib/McAxios'
    export default {
        name: 'MainMenu',
        data: function () {
            return  {
                items: []
            }
        },
        mounted() {
            axios.get('/shop-api/taxons')
                .then( response => {
                    this.items = response.data.find((el)=>{
                        return el.code == 'PROD'
                    }).children
                })
                .catch(()=>{
                    this.items = []
                })
        },
        methods: {
            isActive: function (el) {
                if (this.$route.path == el.slug.replace('_','/')) {
                    return ' active '
                } else {
                    return ''
                }
            },
            goTo: function (href) {
                this.$router.push('/menu/'+href)
                console.log(href)

            }
        }
    }
</script>
<style>
    .looping-rhombuses-spinner, .looping-rhombuses-spinner * {
        box-sizing: border-box;
    }

    .looping-rhombuses-spinner {
        width: calc(15px * 4);
        height: 15px;
        position: relative;
    }

    .looping-rhombuses-spinner .rhombus {
        height: 15px;
        width: 15px;
        background-color: #cbb27c;
        left: calc(15px * 4);
        top: 0.4rem;
        position: absolute;
        margin: 0 auto;
        border-radius: 2px;
        transform: translateY(0) rotate(45deg) scale(0);
        animation: looping-rhombuses-spinner-animation 2500ms linear infinite;
    }

    .looping-rhombuses-spinner .rhombus:nth-child(1) {
        animation-delay: calc(2500ms * 1 / -1.5);
    }

    .looping-rhombuses-spinner .rhombus:nth-child(2) {
        animation-delay: calc(2500ms * 2 / -1.5);
    }

    .looping-rhombuses-spinner .rhombus:nth-child(3) {
        animation-delay: calc(2500ms * 3 / -1.5);
    }

    @keyframes looping-rhombuses-spinner-animation {
        0% {
            transform: translateX(0) rotate(45deg) scale(0);
        }
        50% {
            transform: translateX(-233%) rotate(45deg) scale(1);
        }
        100% {
            transform: translateX(-466%) rotate(45deg) scale(0);
        }
    }
</style>